export default "__VITE_ASSET__CVGyxici__"